import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import type { ModelFile as CustomGeoJSONFile } from "@mm/metx-workbench.meteomatics.com";

type CustomGeoJsonFilesSelectProps = {
  selectedFileId?: number | null;
  list: CustomGeoJSONFile[];
  onChange: (user_file_id: number) => void;
};
export function CustomGeoJsonFileSelect({ selectedFileId, list, onChange }: CustomGeoJsonFilesSelectProps) {
  return (
    <FormField label={t`File`}>
      <select
        disabled={list.length === 0}
        value={selectedFileId && selectedFileId >= 0 ? selectedFileId : ""}
        onChange={(event) => onChange(+event.target.value)}
        data-testid="geojson-file-select"
      >
        {(list.length === 0 || selectedFileId == null || selectedFileId <= 0) && (
          <option value="" disabled={!!selectedFileId}>
            {list.length === 0 ? t`Please upload a GeoJSON first` : t`Please select a GeoJSON file`}
          </option>
        )}

        {list.map((geoJsonItem: CustomGeoJSONFile) => {
          return (
            <option key={geoJsonItem.user_file_id} value={geoJsonItem.user_file_id}>
              {geoJsonItem.label}
            </option>
          );
        })}
      </select>
    </FormField>
  );
}
